import { sqliteTable, text, integer, index } from "drizzle-orm/sqlite-core";

// ============================================================================
// designations — ตำแหน่ง (Designation)
// ============================================================================
export const designations = sqliteTable("hr_designations", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull(),
  name: text("name").notNull(),
  isActive: integer("is_active").notNull().default(1),
  // Audit columns
  createdBy: text("created_by"),
  createdAt: text("created_at").notNull(),
  updatedBy: text("updated_by"),
  updatedAt: text("updated_at").notNull(),
  deletedBy: text("deleted_by"),
  deletedAt: text("deleted_at"),
}, (table) => ({
  desg_company_idx: index("desg_company_idx").on(table.companyId, table.isActive),
}));

// Type exports
export type Designation = typeof designations.$inferSelect;
export type NewDesignation = typeof designations.$inferInsert;
